import {Injectable} from "@angular/core";
import {FirebaseApp} from "@angular/fire";
// I am importing simple ionic storage (local one), in prod this should be remote storage of some sort.
import {Storage} from '@ionic/storage';
import {Platform} from "ionic-angular";
import { Subject } from "rxjs";

@Injectable()
export class FirebaseMessagingProvider {
  private messaging;
  public isNotification = new Subject<any>();
  public isNotifActive: boolean = false;
  private unsubscribeOnTokenRefresh = () => {
  };

  constructor(
    private storage: Storage,
    public platform: Platform,
    public app: FirebaseApp
  ) {
    if (this.platform.is('cordova')) {

    } else {
      // this.messaging = this.app.messaging();
      // navigator.serviceWorker.register('service-worker.js').then((registration) => {
      //   console.log("register firebase", registration);
      //   this.messaging.useServiceWorker(registration);
      //   //this.disableNotifications()
      //   // this.enableNotifications();
      // });
    }

  }

  public enableNotifications(): Promise<any> {
    console.log('Requesting permission...');
    return this.messaging.requestPermission().then(() => {
      console.log('Permission granted');
      // token might change - we need to listen for changes to it and update it
      this.setupOnTokenRefresh();
      return this.updateToken();
    });
  }

  public disableNotifications() {
    this.unsubscribeOnTokenRefresh();
    this.unsubscribeOnTokenRefresh = () => {
    };
    return this.storage.set('fcmToken', '').then();
  }

  private updateToken() {
    console.log("update token firebase")
    return this.messaging.getToken().then((currentToken) => {
      console.log("current token", currentToken)
      if (currentToken) {
        // we've got the token from Firebase, now let's store it in the database
        return this.storage.set('fcmToken', currentToken);
      } else {
        console.log('No Instance ID token available. Request permission to generate one.');
      }
    });
  }

  private setupOnTokenRefresh(): void {
    this.unsubscribeOnTokenRefresh = this.messaging.onTokenRefresh(() => {
      console.log("Token refreshed");
      this.storage.set('fcmToken', '').then(() => {
        this.updateToken();
      });
    });
  }

  public onMessages() {
    console.log("on message firebase");
    this.messaging.onMessage((result) => {
      console.log("message firebase", result)
    })

  }

}



// WEBPACK FOOTER //
// ./src/providers/fcm-service/firebase-messaging.ts